import { render } from "./VeeCompaniesDropdown.vue?vue&type=template&id=70d2a3fd"
import script from "./VeeCompaniesDropdown.vue?vue&type=script&lang=js"
export * from "./VeeCompaniesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__